<template>
  <v-btn
    class="w-100 d-flex justify-space-between font-weight-bold"
    :class="{ 'link-box--active': available, 'text-primary': available }"
    height="30"
    variant="flat"
    rounded="0"
    :disabled="!available"
    :to="tabRoute"
    replace
    :text="text"
  >
    <template #append>
      <v-icon :disabled="!available">mdi-chevron-right</v-icon>
    </template>
  </v-btn>
</template>

<script>
import { useScenariosStore } from '@/stores/scenarios';
import { mapState } from 'pinia';

export default {
  props: {
    available: {
      required: false,
      type: Boolean,
      default: true,
    },
    tab: {
      required: true,
      type: String,
    },
    text: {
      required: true,
      type: String,
    },
    replace: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(useScenariosStore, ['selectedScenario']),
    tabRoute() {
      const params = { scenarioId: this.selectedScenario._id };
      return { name: this.tab, params };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.bg-white[disabled] {
  // The space section has white bg, so we need to change the base color of the button when it's disabled
  color: $assortment-primary-colour !important;
}
.link-box--active {
  background-color: $assortment-scenarios-colour;
}
</style>
